import { cn } from '../../lib/cn.js';
import { forwardRef } from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  icon?: React.ReactNode;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { label, error, icon, className, id, ...props },
  ref
) {
  return (
    <div className="w-full">
      {label && (
        <label
          htmlFor={id}
          className="block text-sm font-medium text-primary-text mb-1"
        >
          {label}
        </label>
      )}
      <div className="relative">
        {icon && (
          <div className="absolute left-3 top-1/2 -translate-y-1/2 text-secondary pointer-events-none">
            {icon}
          </div>
        )}
        <input
          ref={ref}
          id={id}
          className={cn(
            'w-full border border-border rounded-lg px-3 py-2 text-sm text-primary-text',
            'focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary',
            'placeholder:text-secondary disabled:bg-hover-bg disabled:cursor-not-allowed',
            'min-h-[44px]',
            icon && 'pl-9',
            error && 'border-danger focus:border-danger focus:ring-danger',
            className
          )}
          {...props}
        />
      </div>
      {error && <p className="mt-1 text-xs text-danger">{error}</p>}
    </div>
  );
});
